import { drawPolygon, drawLines } from '@blade-sxp/monitor/components/rtsp-player/libs/utils';
import { mapVertices, mapDirections } from './config/frame-render';
import { uuidXplorer } from '@blade/common/utils/uuid';
export default class FrameRenderer {
    showRect = false;
    colors = []; // 标线颜色配置
    rectWidth = 0;
    showAttrsInfo = false; // 是否显示属性
    attrRectConfig; // 叠框属性配置
    canvas;
    ctx;
    contextInfo;
    currDoms = [];
    constructor(config) {
        this.canvas = config.canvas;
        this.ctx = this.canvas.getContext('2d');
        this.contextInfo = config.contextInfo;
    }
    render(tracks, config) {
        console.log('track:', tracks);
        if ((frames instanceof Array && !(frames.length > 0)) || !frames) {
            return;
        }
        // console.log("res:", frames)
        Object.keys(frames).forEach((item) => {
            // console.log("item:", tracks[item])
            this._renderFrame(tracks ? tracks[item] : []);
        });
    }
    _renderFrame(frame) {
        if (!frame || frame.length <= 0) {
            return;
        }
        try {
            frame.forEach((item) => {
                // cross line
                if (item.taskType === 2) {
                    const convertJson = JSON.parse(item.frontEndData);
                    const currDirection = convertJson.allDrawer[0].direction;
                    const res = {
                        queue_line: mapVertices(convertJson.allDrawer[0].vertices, this.contextInfo.width, this.contextInfo.height),
                        directions: mapDirections(currDirection.iconPosition[currDirection.choose], this.contextInfo.width, this.contextInfo.height),
                    };
                    if (res.queue_line) {
                        drawLines(this.ctx, res.queue_line, { lineColor: '#E02020', scale: 1, weight: 2 });
                        // this.generateDir({ x: lineStartX, y: lineStartY }, { x: lineEndX, y: lineEndY }, res.roi);
                        this.generateDir(res.directions);
                    }
                }
                if (item.taskType === 10) {
                    const convertJson = JSON.parse(item.configJson);
                    const res = {
                        roi: convertJson.roiList.map((item) => mapVertices(item.vertices, this.contextInfo.width, this.contextInfo.height)),
                    };
                    if (this.ctx) {
                        res.roi.forEach((item) => {
                            drawPolygon(this.ctx, item, { lineColor: '#f7b500', fillColor: 'rgba(247, 181, 0, 0.5)', weight: 2, scale: 1 });
                        });
                    }
                }
            });
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    generateDir(vertices) {
        const offsetTop = this.canvas.offsetTop || 0;
        const offsetLeft = this.canvas.offsetLeft || 0;
        // const res = calibrateLine({ from: p1, to: p2 }, vertices);
        // const perpCoordinate = getPerpVertex(
        //   { x: res.from.x + offsetLeft, y: res.from.y + offsetTop },
        //   { x: res.to.x + offsetLeft, y: res.to.y + offsetTop },
        //   20
        // );
        const divChild = document.createElement('div');
        this.currDoms.push(divChild);
        const parentNode = this.canvas.parentElement;
        if (!parentNode) {
            return;
        }
        // console.log("parent:",parentNode);
        parentNode.appendChild(divChild);
        // console.log("div child:",parentNode)
        divChild.className = 'crowd-dir';
        divChild.id = `crowd-dir${uuidXplorer()}`;
        divChild.style.left = `${vertices.x + offsetLeft - 10}px`;
        divChild.style.top = `${vertices.y + offsetTop}px`;
        divChild.style.transform = `rotate(${vertices.angle}deg)`;
        divChild.style['transform-origin'] = 'top center';
    }
    clear() {
        this.currDoms.forEach(el => el.remove());
        this.ctx.clearRect(0, 0, this.contextInfo.width, this.contextInfo.height);
    }
}
